import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col, Button, Card, Input, notification, Divider, Modal } from "antd";
import { backendURL } from "../Globals";
import Cookies from "js-cookie";

const DashboardComponent = () => {
    const [dashboards, setDashboards] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [newDashboard, setNewDashboard] = useState({ nombre_editor: "", url_dashboard: "" });
    const [showAdminPanel, setShowAdminPanel] = useState(false);

    useEffect(() => {
        fetchDashboards();
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        setIsLoggedIn(!!apiKey);
    }, []);

    // 🔹 Obtener dashboards de la BD
    const fetchDashboards = async () => {
        try {
            const response = await axios.get(`${backendURL}/dashboards`);
            setDashboards(response.data);
        } catch (error) {
            console.error("Error fetching dashboards:", error);
            notification.error({ message: "Error al obtener los dashboards" });
        }
    };

    const handleAddDashboard = async () => {
      const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
      if (!apiKey) {
          notification.error({ message: "No estás autenticado" });
          return;
      }
  
      // 🔹 Verificar que los valores existen antes de aplicar `.trim()`
      const nombreEditor = newDashboard.nombre_editor ? newDashboard.nombre_editor.trim() : "";
      const urlDashboard = newDashboard.url_dashboard ? newDashboard.url_dashboard.trim() : "";
  
      if (!nombreEditor || !urlDashboard) {
          notification.error({ message: "Debes completar todos los campos" });
          return;
      }
  
      const payload = {
          nombre_editor: nombreEditor,
          url_dashboard: urlDashboard,
          logo_editor: newDashboard.logo_editor || "" // Logo opcional
      };
  
      console.log("🔹 Enviando datos al backend:", payload);
  
      try {
          const response = await axios.post(`${backendURL}/dashboards`, payload, {
              headers: { 
                  Authorization: `Bearer ${apiKey}`,
                  "Content-Type": "application/json"
              }
          });
  
          console.log("✅ Respuesta del servidor:", response.data);
  
          if (response.data.success) {
              setDashboards([...dashboards, response.data.dashboard]);
              setNewDashboard({ nombre_editor: "", url_dashboard: "", logo_editor: "" });
  
              // 🔹 Mostrar mensaje de éxito
              notification.success({
                  message: "✅ Editor añadido correctamente",
                  description: `El editor ${nombreEditor} se ha agregado con éxito.`
              });
          } else {
              notification.error({ message: response.data.error || "⚠️ Error al añadir el editor" });
          }
      } catch (error) {
          console.error("❌ Error al añadir el editor:", error.response?.data || error);
          notification.error({ message: "⚠️ Error al añadir el editor" });
      }
  };
  
  

    // 🔹 Eliminar un editor con confirmación
    const handleDeleteDashboard = (nombre_editor) => {
        Modal.confirm({
            title: "¿Estás seguro de eliminar este editor?",
            content: `Esta acción no se puede deshacer. Eliminarás el dashboard de ${nombre_editor}.`,
            okText: "Sí, eliminar",
            okType: "danger",
            cancelText: "Cancelar",
            onOk: async () => {
                const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
                if (!apiKey) {
                    notification.error({ message: "No estás autenticado" });
                    return;
                }

                try {
                    await axios.delete(`${backendURL}/dashboards/${encodeURIComponent(nombre_editor)}`, {
                        headers: { Authorization: `Bearer ${apiKey}` }
                    });

                    setDashboards(dashboards.filter(dash => dash.nombre_editor !== nombre_editor));
                    notification.success({ message: "Editor eliminado correctamente" });
                } catch (error) {
                    console.error("Error deleting dashboard:", error);
                    notification.error({ message: "Error al eliminar el editor" });
                }
            }
        });
    };

    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h2>Dashboards de Editores</h2>

            {/* 🔹 Dashboards Disponibles */}
            <Row gutter={[16, 16]} justify="center">
                {dashboards.map(dash => (
                    <Col key={dash.nombre_editor} xs={24} sm={12} md={8} lg={6}>
                        <Card
                            title={dash.nombre_editor}
                            bordered={false}
                            style={{
                                textAlign: "center",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                borderRadius: "8px",
                                padding: "12px",
                                backgroundColor: "#ffffff",
                            }}
                        >
                            <a href={dash.url_dashboard} target="_blank" rel="noopener noreferrer">
                                <Button type="primary" danger block>
                                    Acceder
                                </Button>
                            </a>

                            {/* 🔹 Mostrar botón de eliminación solo si está en modo administrador */}
                            {isLoggedIn && showAdminPanel && (
                                <Button
                                    type="link"
                                    danger
                                    onClick={() => handleDeleteDashboard(dash.nombre_editor)}
                                    style={{ marginTop: "8px" }}
                                >
                                    🗑️ Eliminar
                                </Button>
                            )}
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* 🔹 Mostrar botón para activar/desactivar administración */}
            {isLoggedIn && (
                <div style={{ marginTop: "30px" }}>
                    <Button type="dashed" onClick={() => setShowAdminPanel(!showAdminPanel)}>
                        {showAdminPanel ? "Ocultar Administración" : "Administrar Dashboards"}
                    </Button>
                </div>
            )}

            {/* 🔹 Sección de administración oculta por defecto */}
            {isLoggedIn && showAdminPanel && (
                <div style={{
                    marginTop: "30px",
                    padding: "20px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "10px",
                    maxWidth: "400px", // 🔹 Ajuste de ancho para evitar cajas alargadas
                    marginLeft: "auto",
                    marginRight: "auto",
                    textAlign: "left"
                }}>
                    <h3>Añadir nuevo editor</h3>
                    <Divider />
                    <Input
                        placeholder="Nombre del Editor"
                        value={newDashboard.nombre_editor}
                        onChange={e => setNewDashboard({ ...newDashboard, nombre_editor: e.target.value })}
                        style={{ marginBottom: "10px", width: "100%" }}
                    />
                    <Input
                        placeholder="URL del Dashboard"
                        value={newDashboard.url_dashboard}
                        onChange={e => setNewDashboard({ ...newDashboard, url_dashboard: e.target.value })}
                        style={{ marginBottom: "10px", width: "100%" }}
                    />
                    <Button type="primary" onClick={handleAddDashboard} style={{ width: "100%", marginTop: "10px" }}>
                        Añadir Editor
                    </Button>
                </div>
            )}
        </div>
    );
};

export default DashboardComponent;
